import { DECIMAL_DIGITS_ALLOWED, DECIMAL_POINT_CHAR, ONE_DECIMAL_POINT, SEPARATOR } from './constants';

export const currencyFormat = (currency: string, value: string | number): string =>
  currency === 'MXN'
    ? Number(value).toLocaleString('es-MX', {
        currency: 'MXN',
        style: 'currency',
      })
    : Number(value).toLocaleString('en', {
        currency: 'USD',
        currencyDisplay: 'code',
        style: 'currency',
      });

export const apiAmountToCurrencyString = (integer: number): string => (integer / 100).toFixed(2);

export const numberWithTwoDecimals = (value: string): string => {
  let decimalPointCounter: number = 0;
  let decimalsCounter: number = 0;
  return value
    .split('')
    .map((char: string) => {
      if (Number.isFinite(Number(char)) && decimalsCounter < DECIMAL_DIGITS_ALLOWED) {
        if (decimalPointCounter === ONE_DECIMAL_POINT) {
          decimalsCounter++;
        }
        return char;
      } else if (char === DECIMAL_POINT_CHAR && decimalPointCounter < ONE_DECIMAL_POINT) {
        decimalPointCounter++;
        return char;
      }
    })
    .join(SEPARATOR);
};

export const parseAmountTextToInteger = (value: string): number => Math.trunc(Number(value) * 100);

/**
 * parses an amount with centims in integer format to currency format
 * @param currency currency
 * @param value value with decimals as a integer ej. 2100,75 -> 20075
 * @returns value as a currency ej. $2,100.75
 */
export const parseAmountToCurrency = (currency: string, value: string | number): string =>
  currencyFormat(currency, apiAmountToCurrencyString(Number(value)));
